import React, { useState, useEffect } from 'react';
import Header from './Header.jsx';
import { Link } from 'react-router-dom';
import translations from './translation.js';
import Podium from './Podium.jsx';
import Level from './Level.jsx';
import Default from '../assets/default_pfp.png';
import './Rankings.css';
import './Feed.css';

const Rankings = () => {

    const [members, setMembers] = useState([]);
    const currentLanguage = localStorage.getItem("selectedLanguage") || "en";


    const fetchUsersWithXP = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_PATH}/users`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch users: ${response.status} ${response.statusText}`);
            }

            const responseData = await response.json();

            if (!Array.isArray(responseData) || responseData.length === 0) {
                throw new Error('Invalid response format: users array is missing or empty');
            }

            const usersArray = responseData[0];

            const usersWithFind = usersArray.filter(user => user.attributes && user.attributes.exp && user.attributes.username);

            usersWithFind.sort((a, b) => {
                return b.attributes.exp - a.attributes.exp;
            });

            setMembers(usersWithFind);
            console.log(usersWithFind);

        } catch (error) {
            console.error('Error fetching users:', error.message);
            alert(`Failed to fetch users: ${error.message}`);
        }
    };

    useEffect(() => {
        fetchUsersWithXP();
    }, []);


    return (
        <div className="feed-container">
            <Header />
            <h1>{translations[currentLanguage].rankings}</h1>
            <div className="ranking-content-container">
                <Podium />
                <aside className='ranking-content'>
                    {/* <div className='ranking-info'> */}
                        <h2>{translations[currentLanguage].leaderboard}</h2>
                        <p id='twitch-text'>{translations[currentLanguage].ranking_content}</p>
                        <br/>
                        {/* <div className='ranking-holder'> */}
                            {/* <div className='ranking-member-info'> */}
                                <div className='ranking_holder_2'>
                                    {members.map((member) => (
                                        <div key={member.id} style={{ backgroundColor: '#d1b140', padding: '10px', marginBottom: '10px', borderRadius: '10px', alignItems: 'center', width: "100%" }}>
                                            <Link to={`/user/${member.id}`} style={{ textDecoration: 'none' }}>
                                                <img
                                                    src={member.attributes.picture || Default}
                                                    alt={member.attributes.username}
                                                    style={{ width: '60px', height: '60px', borderRadius: '50%',  }}
                                                />
                                            </Link>
                                            <div>
                                                <Link to={`/user/${member.id}`} style={{ textDecoration: 'none', color: 'black' }}>
                                                    @{member.attributes.username}
                                                </Link>
                                            </div>

                                            <div>
                                                <Level experience={member.attributes.exp} language={currentLanguage} />
                                            </div>

                                            <div>
                                                <span>
                                                    {translations[currentLanguage].xp}:{member.attributes.exp}
                                                </span>
                                            </div>

                                        </div>
                                    ))}
                                </div>
                            {/* </div> */}
                        {/* </div> */}
                    {/* </div> */}
                </aside>

            </div>
        </div>
    )


}

export default Rankings;